<div class="row" style="width: 100%; margin: 10px 0px">
    <div class="col-md-12 mt-4 mb-4">
        <div class="container">
            <div class="row">
                <div class="pricing_details">
                    <div class="bolt_pricing" *ngFor="let srd of sharedContentsList">
                        <div class="pricing_details-wrap">
                            <div class="price_haed">
                                <img [src]="srd.image" alt="bolt" />
                            </div>
                            <div class="product_spec_details">
                                <h3>{{ srd.heading }}</h3>
                            </div>
                            <div class="product_details">
                                <p>{{ srd.subHeading }}</p>
                                <a *ngIf="srd.isPurchase" href="javascript:void(0)"> {{ srd.price }} </a>
                            </div>
                            <a
                                href="javascript:void(0)"
                                (click)="openSignUpFlow()"
                                class="active_btn"
                                *ngIf="srd.isPurchase !== true"
                                #tooltip="matTooltip"
                                matTooltip="{{ srd.navigationText }}"
                                [matTooltipPosition]="'above'"
                                aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                            >
                                {{ srd.navigationText.length > 15 ? (srd.navigationText | slice: 0 : 15) + '...' : srd.navigationText }}
                            </a>
                            <a
                                [href]="srd.navigationLink"
                                target="_blank"
                                *ngIf="srd.isPurchase === true"
                                class="active_btn yellow-btn"
                                #tooltip="matTooltip"
                                matTooltip="{{ srd.navigationText }}"
                                [matTooltipPosition]="'above'"
                                aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                            >
                                {{ srd.navigationText.length > 15 ? (srd.navigationText | slice: 0 : 15) + '...' : srd.navigationText }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
